export default __webpack_public_path__ + "static/about-3e62f5ca4b5f997a40920ea32a935156.png";